"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const HttpClientException_1 = __importDefault(require("../../Exception/HttpClientException"));
class MockGraphqlClient {
    constructor(map) {
        this.map = map;
    }
    async fetch(operationName) {
        var _a;
        if (!this.map.has(operationName)) {
            throw new HttpClientException_1.default(`operation named ${operationName} was not described`);
        }
        return (_a = this.map.get(operationName)) === null || _a === void 0 ? void 0 : _a.data;
    }
}
exports.default = MockGraphqlClient;
//# sourceMappingURL=MockGraphqlClient.js.map